export default "__VITE_ASSET__BvLTvOrt__"